import { addOrderTicketVoucherForShowtime, addThirdPartyMemberCardForOrderShowtime, createStandardOrder, hasOrderBeenCreated, TicketRedemptionCodeCategory } from '@vista/omnichannel-components-domain';
export const handleSubmit = async (selectedType, formData, showtimeContext, config) => {
    if (!selectedType)
        return;
    const { showtime, showtimeId } = showtimeContext;
    const { attemptToAutomaticallyAddTickets } = config;
    if (!hasOrderBeenCreated()) {
        if (!showtime)
            throw new Error('Cannot add ticket redemption code without a showtime.');
        await createStandardOrder(showtime.siteId);
    }
    switch (selectedType.category) {
        case TicketRedemptionCodeCategory.Voucher: {
            const credentials = {
                barcode: formData.code,
                pin: formData.pin || undefined // Use undefined instead of empty string as addVoucher checks PIN length
            };
            await addOrderTicketVoucherForShowtime(showtimeId, credentials, attemptToAutomaticallyAddTickets);
            break;
        }
        case TicketRedemptionCodeCategory.ThirdPartyMemberCard: {
            const credentials = {
                cardNumber: formData.code,
                thirdPartyMemberSchemeId: selectedType.thirdPartyMemberSchemeId
            };
            await addThirdPartyMemberCardForOrderShowtime(showtimeId, credentials, attemptToAutomaticallyAddTickets);
            break;
        }
        default: {
            throw new Error(`Cannot add code for unsupported ticket redemption code type: '${TicketRedemptionCodeCategory}'`);
        }
    }
};
